import {Injectable} from "@angular/core";
import {GenericCrudService} from "./generic-crud.service";
import {HttpClient} from "@angular/common/http";
import {DataService} from "./data.service";
import {ToastController} from "@ionic/angular";
import {GenericResponse} from "../model/Responses/GenericResponse";
import {EmailTemplate} from "../model/EmailTemplate";

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateService extends GenericCrudService<EmailTemplate> {


    private url = '/mails/template';

    constructor(
        private http: HttpClient,
        private dataService: DataService,
        private toastContoller: ToastController
    ) {
        super(dataService, http, dataService.getBackendURL() + '/mails/template', toastContoller);
    }

}